// https://image3.slideserve.com/6573221/the-southern-states-part-2-n.jpg
export const usaStatesWestern = [
  'WA',
  'OR',
  'CA',
  'ID',
  'NV',
  'UT',
  'AZ',
  'MT',
  'WY',
  'CO',
  'NM',
  'ND',
  'SD',
  'NE',
  'KS',
  'OK',
  'TX',
  'AK',
  'HI',
];

export const timezonesConfig = [
  { caption: 'HAWAII', abbr: 'HST', jsTimezone: 'Pacific/Honolulu' },
  { caption: 'ALASKA', abbr: 'AKST', jsTimezone: 'America/Yakutat' },
  { caption: 'PACIFIC', abbr: 'PST', jsTimezone: 'America/Los_Angeles' },
  { caption: 'MOUNTAIN', abbr: 'MST', jsTimezone: 'America/Denver' },
  { caption: 'CENTRAL', abbr: 'CST', jsTimezone: 'America/Chicago' },
  { caption: 'EASTERN', abbr: 'EST', jsTimezone: 'America/New_York' },
  { caption: 'ATLANTIC', abbr: 'AST', jsTimezone: 'America/Puerto_Rico' },
];

export const STATE_ABBREVIATION_NAME_MAP = {
  AL: 'Alabama',
  AK: 'Alaska',
  // "AS": "American Samoa",
  AZ: 'Arizona',
  AR: 'Arkansas',
  CA: 'California',
  CO: 'Colorado',
  CT: 'Connecticut',
  DE: 'Delaware',
  DC: 'District Of Columbia',
  // "FM": "Federated States Of Micronesia",
  FL: 'Florida',
  GA: 'Georgia',
  // "GU": "Guam",
  HI: 'Hawaii',
  ID: 'Idaho',
  IL: 'Illinois',
  IN: 'Indiana',
  IA: 'Iowa',
  KS: 'Kansas',
  KY: 'Kentucky',
  LA: 'Louisiana',
  ME: 'Maine',
  // "MH": "Marshall Islands",
  MD: 'Maryland',
  MA: 'Massachusetts',
  MI: 'Michigan',
  MN: 'Minnesota',
  MS: 'Mississippi',
  MO: 'Missouri',
  MT: 'Montana',
  NE: 'Nebraska',
  NV: 'Nevada',
  NH: 'New Hampshire',
  NJ: 'New Jersey',
  NM: 'New Mexico',
  NY: 'New York',
  NC: 'North Carolina',
  ND: 'North Dakota',
  // "MP": "Northern Mariana Islands",
  OH: 'Ohio',
  OK: 'Oklahoma',
  OR: 'Oregon',
  // "PW": "Palau",
  PA: 'Pennsylvania',
  PR: 'Puerto Rico',
  RI: 'Rhode Island',
  SC: 'South Carolina',
  SD: 'South Dakota',
  TN: 'Tennessee',
  TX: 'Texas',
  UT: 'Utah',
  VT: 'Vermont',
  // "VI": "Virgin Islands",
  VA: 'Virginia',
  WA: 'Washington',
  WV: 'West Virginia',
  WI: 'Wisconsin',
  WY: 'Wyoming',
};

export const STATE_NAME_ABBREVIATION_MAP = {
  Alabama: 'AL',
  Alaska: 'AK',
  Arizona: 'AZ',
  Arkansas: 'AR',
  California: 'CA',
  Colorado: 'CO',
  Connecticut: 'CT',
  Delaware: 'DE',
  Florida: 'FL',
  Georgia: 'GA',
  Hawaii: 'HI',
  Idaho: 'ID',
  Illinois: 'IL',
  Indiana: 'IN',
  Iowa: 'IA',
  Kansas: 'KS',
  Kentucky: 'KY',
  Louisiana: 'LA',
  Maine: 'ME',
  Maryland: 'MD',
  Massachusetts: 'MA',
  Michigan: 'MI',
  Minnesota: 'MN',
  Mississippi: 'MS',
  Missouri: 'MO',
  Montana: 'MT',
  Nebraska: 'NE',
  Nevada: 'NV',
  'New Hampshire': 'NH',
  'New Jersey': 'NJ',
  'New Mexico': 'NM',
  'New York': 'NY',
  'North Carolina': 'NC',
  'North Dakota': 'ND',
  Ohio: 'OH',
  Oklahoma: 'OK',
  Oregon: 'OR',
  Pennsylvania: 'PA',
  'Puerto Rico': 'PR',
  'Rhode Island': 'RI',
  'South Carolina': 'SC',
  'South Dakota': 'SD',
  Tennessee: 'TN',
  Texas: 'TX',
  Utah: 'UT',
  Vermont: 'VT',
  Virginia: 'VA',
  Washington: 'WA',
  'West Virginia': 'WV',
  Wisconsin: 'WI',
  Wyoming: 'WY',
  'District of Columbia': 'DC',
};

export const ITALY_REGION_NAME_TO_CODE: Record<string, string> = {
  Abruzzo: 'ABR',
  "Valle d'Aosta": 'VAL',
  Puglia: 'PUG',
  Basilicata: 'BAS',
  Calabria: 'CAL',
  Campania: 'CAM',
  'Emilia Romagna': 'EMI',
  'Friuli-Venezia Giulia': 'FRI',
  Lazio: 'LAZ',
  Liguria: 'LIG',
  Lombardia: 'LOM',
  Marche: 'MAR',
  Molise: 'MOL',
  Piemonte: 'PIE',
  Sardegna: 'SAR',
  Sicilia: 'SIC',
  'Trentino-Alto Adige': 'TRE',
  Toscana: 'TOS',
  Umbria: 'UMB',
  Veneto: 'VEN',
};

// Ids hardcoded on the NOP-BE
export const ITALY_REGION_ID = '647d8ca9-6dd3-4423-a8f5-c5226e38a4bb'; // Italy
export const NA_REGION_ID = 'cd1de1df-111c-4278-a7c6-a6dbfa5e49b9'; // North America
export const ITALY_REGION_NAME = 'Italy';

export const US_CENTER_COORDS: [number, number] = [-98.5795, 39.8283]; // lon, lat
